/* サイドピークの共有コントローラ（一覧ハブとTOPで同じ挙動を使う）。
 * URLパラメータ ?nm_peek=<handle> を唯一の状態源にする。履歴エントリは常に現在の
 * ドキュメントのままなので、戻る・進む・再読込み・BFCache のどの経路でも表示とURLが
 * 食い違わない。記事の実URLへ pushState する方式は、戻った先でサーバーが記事ページを
 * 返してしまうため採らない。
 * 取得は記事URL + ?view=news-matome-peek の layout なし断片。挿入前に allowlist で検証し、
 * transport の noindex メタは取り込まない（マーカー要素だけを移す）。
 */
(function () {
  'use strict';
  var PARAM = 'nm_peek', VIEW = 'news-matome-peek', BLOG = '/blogs/media/';
  // 表は専用テキストの「事実」欄（nmp-facts）。2026-09-29 に専用テキストが記事へ入るまで出番がなく、許可に漏れていた。
  var TAGS = ['DIV', 'P', 'H2', 'H3', 'OL', 'UL', 'LI', 'A', 'SPAN', 'TIME', 'STRONG', 'EM', 'BR', 'TABLE', 'TBODY', 'TR', 'TH', 'TD'];
  var ATTRS = /^(?:class|href|datetime|role|scope|data-[a-z0-9-]+|aria-[a-z-]+)$/;
  var CARRY = ['preview_theme_id', '_fd', 'pb'];
  var instance = null;

  function supported() {
    return typeof window.HTMLDialogElement === 'function' && typeof document.createElement('dialog').showModal === 'function';
  }
  function normalise(value) {
    if (!value || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) || value === 'news-matome' || value.indexOf('-news-matome') < 0) return '';
    return value;
  }
  function handleFromHref(href) {
    var target;
    try { target = new URL(href, location.origin); } catch (error) { return ''; }
    if (target.origin !== location.origin) return '';
    var match = /^\/blogs\/media\/([a-z0-9-]+)$/.exec(target.pathname);
    return match ? normalise(match[1]) : '';
  }
  function carry(target) {
    CARRY.forEach(function (key) {
      var current = new URL(location.href).searchParams.get(key);
      if (current) target.searchParams.set(key, current);
    });
    return target;
  }
  function articlePath(handle) { return BLOG + handle; }
  function articleUrl(handle) {
    var target = carry(new URL(articlePath(handle), location.origin));
    return target.pathname + target.search;
  }
  function transportUrl(handle) {
    var target = carry(new URL(articlePath(handle), location.origin));
    target.searchParams.set('view', VIEW);
    return target.href;
  }
  function peekUrl(handle) {
    var target = new URL(location.href);
    target.searchParams.set(PARAM, handle);
    return target.pathname + target.search;
  }
  function closedUrl() {
    var target = new URL(location.href);
    target.searchParams.delete(PARAM);
    return target.pathname + target.search;
  }
  function decorate(scope) {
    scope.querySelectorAll('a[href]').forEach(function (anchor) {
      var target = new URL(anchor.getAttribute('href'), location.origin);
      if (target.origin !== location.origin) return;
      carry(target);
      anchor.href = target.pathname + target.search + target.hash;
    });
  }
  function validate(node) {
    if (!node || node.dataset.nmaPeek !== '1') throw new Error('Peek marker missing');
    [node].concat(Array.prototype.slice.call(node.querySelectorAll('*'))).forEach(function (element) {
      if (TAGS.indexOf(element.tagName) < 0) throw new Error('Unexpected peek element');
      Array.prototype.slice.call(element.attributes).forEach(function (attribute) {
        if (!ATTRS.test(attribute.name)) throw new Error('Unexpected peek attribute');
      });
      if (element.matches('a[href]')) {
        var link = new URL(element.getAttribute('href'), location.origin);
        if (link.origin !== location.origin || !/^\/blogs\/media\/[a-z0-9-]+$/.test(link.pathname)) throw new Error('Invalid peek link');
      }
    });
    return node;
  }

  function build(options) {
    var settings = Object.assign({}, options || {});
    var state = { open: false, closing: false, handle: '', trigger: null, pushed: false, token: 0 };
    var els = null;

    function ensure() {
      if (els) return els;
      var dialog = document.createElement('dialog');
      dialog.className = 'nma-peek';
      dialog.setAttribute('aria-label', '記事の概要');
      var bar = document.createElement('div');
      bar.className = 'nma-peek-bar';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'nma-peek-close';
      close.setAttribute('aria-label', '閉じる');
      close.textContent = '×';
      var expand = document.createElement('a');
      expand.className = 'nma-peek-expand';
      expand.textContent = '全画面で開く ↗';
      var content = document.createElement('div');
      content.className = 'nma-peek-content';
      bar.appendChild(close);
      bar.appendChild(expand);
      dialog.appendChild(bar);
      dialog.appendChild(content);
      document.body.appendChild(dialog);
      close.addEventListener('click', function () { requestClose(); });
      // Esc はブラウザが cancel を出す。既定の close だけではURLが取り残されるため横取りする。
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); requestClose(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) requestClose(); });
      els = { dialog: dialog, content: content, expand: expand, close: close };
      return els;
    }
    function status(text) {
      var node = document.createElement('p');
      node.className = 'nma-peek-status';
      node.textContent = text;
      return node;
    }
    function track(handle) {
      if (!settings.analytics) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'virtual_page_view', page_location: location.origin + articlePath(handle), nm_peek: true });
      } catch (error) { /* noop */ }
    }
    function fetchFragment(handle, token) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 15000);
      return fetch(transportUrl(handle), { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Peek request failed');
          if (response.url) {
            var finalUrl = new URL(response.url);
            if (finalUrl.origin !== location.origin || finalUrl.pathname !== articlePath(handle)) throw new Error('Peek request redirected');
          }
          return response.text();
        })
        .then(function (html) {
          if (token !== state.token) throw new Error('Obsolete peek');
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var found = parsed.querySelectorAll('[data-nma-peek]');
          if (found.length !== 1) throw new Error('Peek response is not a fragment');
          return validate(found[0]);
        })
        .finally(function () { clearTimeout(timer); });
    }
    function show(handle, config) {
      config = config || {};
      var view = ensure(), token = ++state.token;
      state.open = true; state.closing = false; state.handle = handle; state.pushed = Boolean(config.pushed);
      if (config.trigger) state.trigger = config.trigger;
      view.expand.href = articleUrl(handle);
      view.content.replaceChildren(status('読み込み中…'));
      view.dialog.setAttribute('aria-busy', 'true');
      if (!view.dialog.open) view.dialog.showModal();
      document.documentElement.classList.add('nma-peek-locked');
      view.dialog.scrollTop = 0;
      if (settings.onOpen) settings.onOpen(handle);
      return fetchFragment(handle, token).then(function (node) {
        if (token !== state.token || !state.open) return;
        decorate(node);
        view.content.replaceChildren(node);
        view.dialog.setAttribute('aria-busy', 'false');
        view.dialog.scrollTop = 0;
      }).catch(function () {
        if (token !== state.token || !state.open) return;
        view.dialog.setAttribute('aria-busy', 'false');
        // 利用者の操作で開いた場合は記事ページへ送る（内容は必ず読める）。共有URL起点で
        // 失敗し続けると戻れなくなるため、その場合はパラメータを外して静かに閉じる。
        if (state.pushed) { window.location.href = articleUrl(handle); return; }
        history.replaceState(history.state, '', closedUrl());
        hide();
      });
    }
    function hide() {
      state.token += 1;
      state.open = false; state.closing = false; state.handle = ''; state.pushed = false;
      document.documentElement.classList.remove('nma-peek-locked');
      if (els && els.dialog.open) els.dialog.close();
      var trigger = state.trigger;
      state.trigger = null;
      if (trigger && document.contains(trigger)) { try { trigger.focus({ preventScroll: true }); } catch (error) { /* noop */ } }
      if (settings.onClose) settings.onClose();
    }
    function requestClose() {
      if (!state.open || state.closing) return;
      if (state.pushed) {
        state.closing = true;
        history.back();
        setTimeout(function () {
          if (!state.closing) return;
          state.closing = false;
          history.replaceState(history.state, '', closedUrl());
          hide();
        }, 400);
      } else {
        history.replaceState(history.state, '', closedUrl());
        hide();
      }
    }
    function open(handle, trigger) {
      var target = normalise(handle);
      if (!target || !supported()) return false;
      try { history.pushState(Object.assign({}, history.state || {}), '', peekUrl(target)); }
      catch (error) { return false; }
      show(target, { pushed: true, trigger: trigger });
      track(target);
      return true;
    }
    function syncFromUrl() {
      var raw = new URL(location.href).searchParams.get(PARAM) || '';
      var handle = normalise(raw);
      if (handle && supported()) {
        if (!state.open || state.handle !== handle) { show(handle, { pushed: false }); track(handle); }
        return;
      }
      if (state.open) hide();
      if (raw) history.replaceState(history.state, '', closedUrl());
    }

    window.addEventListener('popstate', function () { state.closing = false; syncFromUrl(); });
    window.addEventListener('pageshow', function () { state.closing = false; syncFromUrl(); });

    return {
      param: PARAM,
      open: open,
      close: requestClose,
      syncFromUrl: syncFromUrl,
      supported: supported,
      handleFromHref: handleFromHref,
      isOpen: function () { return state.open; },
      handle: function () { return state.handle; },
      setAnalytics: function (value) { settings.analytics = Boolean(value); },
    };
  }

  window.NewsMatomePeek = {
    // ページ内で1つのダイアログを共有する。TOPと一覧の両方から呼ばれても二重に作らない。
    controller: function (options) {
      if (!instance) instance = build(options);
      if (options && options.analytics) instance.setAnalytics(true);
      return instance;
    },
    handleFromHref: handleFromHref,
    supported: supported,
  };
}());
